import { createSelector } from "redux-starter-kit";

export default createSelector(
  ["invited.steps"],
  step => step
);
